import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TimeIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TimeIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.93358 26.425C10.1287 27.8891 12.7075 28.6692 15.346 28.6667C18.8775 28.6598 22.2617 27.2542 24.7579 24.7576C27.2541 22.261 28.6603 18.877 28.6667 15.3464C28.6692 12.7081 27.8892 10.1285 26.4245 7.93385C24.9611 5.73921 22.879 4.02824 20.4413 3.01746C18.0048 2.00667 15.3231 1.74149 12.7354 2.25558C10.1478 2.76966 7.77098 4.03975 5.90486 5.90522C4.04001 7.77077 2.76968 10.1477 2.2552 12.7354C1.74198 15.323 2.00621 18.0049 3.0174 20.4418C4.02858 22.8787 5.73845 24.9609 7.93358 26.425ZM9.02352 5.86854C10.896 4.61846 13.0962 3.95122 15.346 3.95122C18.3655 3.95122 21.2606 5.16343 23.3948 7.29797C25.5289 9.43252 26.7281 12.3276 26.7281 15.3464C26.7256 17.597 26.0561 19.7963 24.8036 21.6664C23.551 23.5365 21.7726 24.9933 19.693 25.8527C17.6135 26.7123 15.3244 26.9358 13.1178 26.4951C10.9112 26.0545 8.88379 24.9695 7.29333 23.3771C5.70288 21.7848 4.62056 19.7567 4.18229 17.5491C3.74403 15.3415 3.97015 13.0537 4.83143 10.9746C5.69399 8.89557 7.15233 7.1187 9.02352 5.86854ZM19.0922 20.1724C19.2713 20.342 19.5088 20.4353 19.7553 20.4326C19.8874 20.4332 20.017 20.4071 20.1377 20.3556C20.2583 20.3041 20.3676 20.2285 20.4578 20.1334C20.6356 19.943 20.7334 19.6915 20.7309 19.4309C20.7182 19.1738 20.6064 18.9315 20.4197 18.7545L16.3089 14.9171V7.46351C16.3241 7.3268 16.3114 7.18825 16.2695 7.05701C16.2288 6.92585 16.1602 6.80485 16.0688 6.70211C15.976 6.59938 15.8643 6.51712 15.7385 6.46083C15.6127 6.40454 15.4768 6.3754 15.3396 6.3754C15.2024 6.3754 15.0665 6.40454 14.9407 6.46083C14.815 6.51712 14.7032 6.59938 14.6104 6.70211C14.5304 6.79135 14.4682 6.89441 14.4275 7.00588L14.4097 7.05701C14.3843 7.13712 14.3691 7.21993 14.3653 7.30337C14.3627 7.35665 14.364 7.41024 14.3703 7.46351V15.3464C14.3691 15.4778 14.3945 15.6081 14.4466 15.729C14.4771 15.8019 14.5164 15.8704 14.5647 15.9331C14.5965 15.9744 14.632 16.0131 14.6701 16.0488L19.0922 20.1724Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default TimeIcon;
